import React, { Component } from 'react';
import Translations from "../../translations/translations.json";
import { connect } from 'react-redux';

class Signup extends Component {
    constructor(props, context) {
        super(props, context);

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);

        this.state = {
          show: false
        };
      }

      handleClose() {
        this.setState({ show: false });
      }

      handleShow() {
        this.setState({ show: true });
      }

  render() {
    return (
      <div>
        S'inscrire
      </div>
    )
  }
}

const mapStateToProps = state => ({
    lang: state.reducerLang.lang
});
export default connect(mapStateToProps)(Signup);